// extracted by mini-css-extract-plugin
export default {"root":"menu-items_root__wG+us","placeHolderShimmer":"menu-items_placeHolderShimmer__IkKGD"};